export default "__VITE_ASSET__$BiSm0N6__"